import "@hotwired/turbo-rails"
import "bootstrap/js/dist/collapse"
